/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for SDUserCoverageInformation.
 *
 */

import { ReduxUtils } from '@spm/core';

const FETCH_SD_EXTERNAL_USER_COVERAGE_INFO = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `SDUSERCOVERAGEINFORMATION/FETCH_SD_EXTERNAL_USER_COVERAGE_INFO`
);

export { FETCH_SD_EXTERNAL_USER_COVERAGE_INFO };
